// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 989 ? "component---src-core-pages-page-template-tsx" : chunkId) + "-" + {"767":"929b0835419f4036ea51","989":"2049de692f5c24312140"}[chunkId] + ".js";
};